import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { LogOut, Headset } from "lucide-react";
import { agentApi } from "@/lib/api";
import LiveChatConsole from "@/components/LiveChatConsole";

export default function AgentConsole() {
    const token = localStorage.getItem("orchid_agent_token");
    const [checked, setChecked] = useState(false);
    const [ok, setOk] = useState(false);
    const [name, setName] = useState(localStorage.getItem("orchid_agent_name") || "Agent");

    useEffect(() => {
        if (!token) {
            setChecked(true);
            return;
        }
        agentApi
            .get("/api/agent/me")
            .then((r) => {
                setName(r.data?.name || "Agent");
                setOk(true);
            })
            .catch(() => setOk(false))
            .finally(() => setChecked(true));
    }, [token]);

    if (!token) return <Navigate to="/agent/login" replace />;
    if (!checked) return <div className="min-h-screen flex items-center justify-center text-stone-400">Loading…</div>;
    if (!ok) return <Navigate to="/agent/login" replace />;

    const logout = () => {
        localStorage.removeItem("orchid_agent_token");
        localStorage.removeItem("orchid_agent_name");
        window.location.assign("/agent/login");
    };

    return (
        <div className="h-screen flex flex-col">
            <div className="px-5 py-2.5 bg-orchid-700 text-white flex items-center justify-between shrink-0">
                <div className="flex items-center gap-2">
                    <Headset size={17} />
                    <span className="font-semibold">Orchid Live Desk</span>
                </div>
                <div className="flex items-center gap-3">
                    <span className="text-sm text-white/80">Signed in as {name}</span>
                    <button
                        onClick={logout}
                        data-testid="agent-logout"
                        className="inline-flex items-center gap-1.5 text-xs bg-white/15 hover:bg-white/25 px-3 py-1.5 rounded-md"
                    >
                        <LogOut size={13} /> Sign out
                    </button>
                </div>
            </div>
            <div className="flex-1 min-h-0">
                <LiveChatConsole api={agentApi} />
            </div>
        </div>
    );
}
